module.exports = __webpack_public_path__ + "static/media/07.56ed0055.jpg";